import { render, staticRenderFns } from "./ManuscriptDeleteConfirm.vue?vue&type=template&id=7471a236&scoped=true&"
import script from "./ManuscriptDeleteConfirm.vue?vue&type=script&lang=ts&"
export * from "./ManuscriptDeleteConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./ManuscriptDeleteConfirm.vue?vue&type=style&index=0&id=7471a236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7471a236",
  null
  
)

export default component.exports